import React, { useState, useEffect } from "react";
import { OI_URL } from "../../config/config";
import { Modal, Button, Form, Alert, Upload, Select } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { ImportOutlined, InboxOutlined } from "@ant-design/icons";
import * as XLSX from 'xlsx';

const { Dragger } = Upload;
const { Option } = Select;

const ImportBinCaidModal = (props) => {
    let { t, fetchBinCaids, merchantList } = props;
    const [formData, setFormData] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [form] = Form.useForm();

    const initFormData = {
        data: "",
    };

    const layout = {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
    };

    const formValInit = () => {
        setFormData(initFormData);
    };

    const showModal = () => {
        formValInit();
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleOk = () => {
        onFinish();
        setIsSubmitting(true);
    };

    const isOkButtonProps = () => false; //!formData || !formData.file_csvfile || !formData.sid;

    useEffect(() => {
        formValInit();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const formValChange = (chgV, allV) => {
        let newFormData = {...formData, ...allV };
        setFormData(newFormData);
        form.setFieldsValue(allV);
    };

    const uploadConfig = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: '.csv',
        beforeUpload(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
              const binaryStr = e.target.result;
              const workbook = XLSX.read(binaryStr, { type: 'binary' });
              const sheetName = workbook.SheetNames[0];
              const sheet = workbook.Sheets[sheetName];
              const jsonData = XLSX.utils.sheet_to_json(sheet);

              // Set data
              setFormData({ ...formData, data: jsonData });
            };
            reader.readAsArrayBuffer(file);
        
            // Prevent default upload
            return false;
        },
        onRemove(e){
            let newFormData = {...formData, data : '' };
            setFormData(newFormData);
        }
    };

    const handleMerchantChange = (value) => {
        const updatedData = formData.data.map(item => ({
            ...item,
            merchantId: value,
        }));

        setFormData({ ...formData, data: updatedData });
    };


    const onFinish = () => {
        const apiUrl = OI_URL + `/api/v1/txshield/bincaids`;
        axios
            .post(apiUrl, formData, { headers: { 
                Authorization: "Bearer " + Cookies.get("txfind_token"),
                // "Content-Type": "multipart/form-data",
                // "Accept": "application/json"
            } })
            .then(({ data }) => {
                if (data.status.toLowerCase() === "ok") {
                    Swal.fire({
                        icon: "success",
                        // title: t("contents.3dsecure.binmid.added"),
                        title: t("added"),
                        text: data.details ? data.details : "",
                        showConfirmButton: false,
                        timer: 2000,
                        onClose: () => {
                            fetchBinCaids();
                            setIsSubmitting(false);
                            form.resetFields();
                        },
                    });
                    handleCancel();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: t("login.dialogs.catch"),
                        text: data.msg ? data.msg : "",
                        showConfirmButton: true,
                    });
                    setIsSubmitting(false);
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: t("login.dialogs.catch"),
                    text: error.response?.data?.msg || "",
                    showConfirmButton: true,
                });
                setIsSubmitting(false);
            });
    }

    const downloadSampleCSV = () => {
        const headers = [{
          bin: '',
          caid: '',
          mcc: '',
          status: '',
          referenceNumber: ''
        }];
      
        // Create csv from headers
        const worksheet = XLSX.utils.json_to_sheet(headers, { skipHeader: false });
        const csv = XLSX.utils.sheet_to_csv(worksheet);
      
        // Create Blob
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'sample_bincaids.csv';
        link.click();
    };

    return (
        <>
        <Button key={`btn_import`} type="link" onClick={showModal} >
            <div className="d-flex align-items-center">
                <ImportOutlined style={{ fontSize: "18px" }} /> <div style={{ marginLeft: "4px" }}>Import CSV</div>
            </div>
        </Button>
        <Modal
            title={t("contents.oi.form.binCaidImport")}
            width={600}
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={() => handleCancel()}>
                    {t("contents.chargebacks.form.cancel")}
                </Button>,
                <Button key="submit" type="primary" loading={isSubmitting} disabled={isOkButtonProps()} onClick={() => handleOk()}>
                    {isSubmitting ? t("contents.chargebacks.form.submitting") : t("contents.chargebacks.form.submit")}
                </Button>,
            ]}
        >
            <Form form={form} {...layout} name="importbincaid" onValuesChange={formValChange}>
                <Alert
                    style={{ marginBottom: 25 }}
                    message={t("contents.oi.form.addbincaidwarning")}
                    type="warning"
                    showIcon
                />
                <Button key="download-sample" type="dashed" onClick={() => downloadSampleCSV()} style={{marginBottom: 10}}>
                    Download Sample CSV Format
                </Button>
                <Dragger {...uploadConfig}>
                    <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                    Support for a single or bulk upload. Strictly prohibited from uploading company data or other
                    banned files.
                    </p>
                </Dragger>
                <Form.Item 
                    name="merchantId" 
                    label={t("contents.oi.form.merchant")} 
                    rules={[{ required: true }]}
                    style={{ marginTop: 18 }}
                >
                    <Select placeholder={t("contents.merchants.form.please_select")} onChange={handleMerchantChange}>
                        {merchantList && merchantList.map((item) => (
                            <Option key={item.merchantId} value={item.merchantId}>
                                {item.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
        </>
    );
};

export default ImportBinCaidModal;